import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../Component/Header'
import { withCookies, Cookies } from 'react-cookie';

export default function Home() {
     
    // useEffect(() => {
    //    const data = localStorage.getItem('userDetails') || 'abc';

    //    if(data == "abc"){
    //     var base_url = window.location.origin;
    //     window.location.href = base_url;
    //    }
    // }, [])
    return (
       
       
            <Header />

    )
}
